import { Component, HostListener, Inject } from '@angular/core';
import { DOCUMENT, PlatformLocation } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterState } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  innerHeight: number = 0;

  constructor(private _platformLocation: PlatformLocation, private router: Router,
    @Inject(DOCUMENT) private document: Document) { }


  handleRouteEvents() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const title = this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
        //this.titleService.setTitle(title);
        gtag('event', 'page_view', {
          page_title: title,
          page_path: event.urlAfterRedirects,
          page_location: this.document.location.href
        })
      }
    });
  }

  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }



  ngAfterViewChecked() {
    if (this.innerHeight != document.body.scrollHeight) {

      this.innerHeight = document.body.scrollHeight;
      window.dispatchEvent(new Event('resize'));
      this.resizeParent();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerHeight = document.body.scrollHeight;
  //  console.log("APP INNER HEIGHT IS " + this.innerHeight);
    this.resizeParent();
  }

  resizeParent() {
    var height = this.innerHeight + 20;
   // console.log("PARENT IS RESIZING");
    var message = { action: "resize", width: "100% !important", height: height + "px !important" };
    window.parent.postMessage(JSON.stringify(message), "*");
  //  console.log("I resized the page successfully - IE issue");
  }

}

